<template>
    <p
        :class="
            twMerge(
                'whitespace-pre-line text-left text-[1rem] leading-[1.6]',
                locale === 'ja' && '',
                locale === 'ko' && '',
                (lang === 'en' || locale === 'en') &&
                    'font-en leading-[1.4] tracking-[-0.01em]',
                $attrs.class,
            )
        "
    >
        <span
            v-if="html && (Array.isArray(html) ? html.length > 0 : true)"
            v-html="htmlPurify(Array.isArray(html) ? html.join('\n') : html)"
        />
        <slot v-else />
    </p>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
import { htmlPurify } from "~/lib/utils";
const { lang = "tw", html = "" } = defineProps({
    lang: { type: String, default: "tw" },
    html: { type: [String, Array], default: "" },
});

const { locale } = useI18n();
</script>
